import React, { Component,useState } from 'react'
import{ AppBar,Toolbar,Typography,Avatar,IconButton} from '@mui/material'
import {GoSignOut,GoPerson,GoGitBranch} from 'react-icons/go'
import {GiArchiveResearch} from 'react-icons/gi'
import{BsLink45Deg} from 'react-icons/bs'
import {useNavigate} from 'react-router-dom'
import Logo from '../Recursos/espolCircle.jpg';
import logoInvestigacion from '../../recursos_iconos/Portal_Investigacion_r.svg';

import {
  Menu,
  MenuItem,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
} from '@mui/material';


interface Props{
  nombreApp: string,
  foto?:string,
  nombres: string,
  apellidos: string,
  abrirModal: (estado: boolean) => void;
  abrirScholar: (estado: boolean) => void;
}

export default function NavMenu (props:Props) {
  const tab = '\u00A0';
  const CAS_OUT = process.env.REACT_APP_CAS_OUT;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorE2, setAnchorE2] = useState<null | HTMLElement>(null);
  const [open, setOpen] = useState(false);
  const history = useNavigate();

  const goToNavigation = (site:string) =>{
    history(site)
  }

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDatosInvestigador = () => {
    setAnchorEl(null);
    goToNavigation('/Usuario/DatosInvestigador')
  };

  const handleSubMenuToggle = () => {
    setOpen(!open);
  };

  const handleMenuOptionClick = (path: string) => {
    history(path);
    handleMenuClose();
  };

  const handleMenuModalOrcId = () => {    
    sendSignal();    
    handleMenuClose();
    //console.log('modal orc');
  };

  const handleMenuModalGoogleScholar = () => {    
    sendSignalScholar();    
    handleMenuClose();
    //console.log('modal orc');
  };


  const handleLogOut = () => {
    window.location.href = CAS_OUT || '';
    {/*
    setTimeout(() => {
      window.location.reload();
    }, 5000); // Recargar después de 5 segundos (ajusta el valor según tus necesidades)
    */}
  };

  const sendSignal = () => {
    props.abrirModal(true); // Emitir la señal para abrir el modal de OrcID
  };

  const sendSignalScholar = () => {
    props.abrirScholar(true); // Emitir la señal para abrir el modal de Google Scholar
  };
    
  return (
      <header>
          <AppBar position="static" style={{backgroundColor:'#ffffff'}}>
           <Toolbar>
            <div className='centrado' style={{ paddingTop:'25px', paddingBottom:'25px'}}>
                <img className='imgBox' width='350px' height='auto' src={logoInvestigacion} alt="" style={{marginLeft:'10%'}} onClick={() => goToNavigation('/')} />
            </div>
            <Typography variant="h6" style={{ marginLeft: '10px', flexGrow: 1 }}>
               {props.nombreApp}
            </Typography>
            <Typography className='userName' variant="body1" component="div">
             <div style={{color:'#243165'}}><strong>{props.nombres}</strong></div>
             <div style={{color:'#243165'}}><strong>{props.apellidos}</strong></div>
            </Typography>
            {tab}
            <Avatar className='avatarNav'
                    alt="foto-usuario" 
                    src={props.foto} 
                    onClick={handleMenuOpen}
                    style={{ width: '80px', height: '80px', borderRadius: '10px' }}
            />
            <Menu
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >              
              {/* <MenuItem onClick={handleSubMenuToggle}>
                <ListItemIcon>
                  <GoPerson />
                </ListItemIcon>
                <ListItemText primary="Datos Personales" />
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </MenuItem> */}
              {/* <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItem button onClick={handleMenuClose}>
                    <ListItemText primary="OrcID" />
                  </ListItem>
                  <ListItem button onClick={handleMenuClose}>
                    <ListItemText primary="Google Scholar" />
                  </ListItem>
                </List>
              </Collapse> */}
              <MenuItem onClick={handleDatosInvestigador}>
                <ListItemIcon>
                  <GoPerson />
                </ListItemIcon>
                <ListItemText primary="Datos Personales" />
              </MenuItem>
              {/* <MenuItem onClick={handleMenuClose}>
                <ListItemIcon>
                  <GoGitBranch />
                </ListItemIcon>
                <ListItemText primary="Mis Redes" />
              </MenuItem>
              <MenuItem onClick={handleMenuClose}>
                <ListItemIcon>
                  <GiArchiveResearch />
                </ListItemIcon>
                <ListItemText primary="Programas de Investigación" />
              </MenuItem> */}
            </Menu>
            <IconButton color="default" style={{ color: '#243165' }} onClick={() => goToNavigation('/inicio/portalinvestigacion')}>
               <BsLink45Deg />
            </IconButton>
            <IconButton color="default" style={{ color: '#243165' }} onClick={handleLogOut}>
               <GoSignOut />
            </IconButton>         
          </Toolbar>
        </AppBar>       
      </header>
    )
  
}
